/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Debt_Due_DateInputs */

const en_case_field_debt_due_date = /** @type {(inputs: Case_Field_Debt_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due date`)
};

const pt_br2_case_field_debt_due_date = /** @type {(inputs: Case_Field_Debt_Due_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vencimento`)
};

/**
* | output |
* | --- |
* | "Due date" |
*
* @param {Case_Field_Debt_Due_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_debt_due_date = /** @type {((inputs?: Case_Field_Debt_Due_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Debt_Due_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_debt_due_date(inputs)
	return pt_br2_case_field_debt_due_date(inputs)
});